import { useCalculator } from "../../hooks/useCalculator";
import { CalculatorPaymentMethodDialog } from "./calculator-payment-method-dialog/CalculatorPaymentMethodDialog";
import { CalculatorPromoCodeDialog } from "./calculator-promo-code-dialog/CalculatorPromoCodeDialog";

export const CalculatorDialogs = () => {
  const isPromoCodeDialogOpen = useCalculator(
    (state) => state.isPromoCodeDialogOpen,
  );
  const isPaymentMethodDialogOpen = useCalculator(
    (state) => state.isPaymentMethodDialogOpen,
  );

  return (
    <>
      {isPromoCodeDialogOpen && <CalculatorPromoCodeDialog />}
      {isPaymentMethodDialogOpen && <CalculatorPaymentMethodDialog />}
    </>
  );
};
